import { createTheme } from "@mui/material/styles";

/**
 * Maps the Talaera design tokens (src/styles/semantic.css) onto MUI. Controls
 * that set their own colour — styled overrides, inline styles, scoped CSS —
 * are unaffected; the rest take the palette from here.
 *
 * react-page pulls in its own nested MUI v5 copy and themes itself; this
 * covers the MUI surface the app owns.
 */
export const muiTheme = createTheme({
  palette: {
    primary: { main: "#25394d" }, // --action-fg
    secondary: { main: "#01bcd4" }, // --action-brand
    error: { main: "#c42b46" }, // --status-danger-fg
    warning: { main: "#c74600" }, // --status-warning-fg
    success: { main: "#22ba7c" }, // --status-success-fill
    info: { main: "#5d6d83" }, // --text-muted
    text: {
      primary: "#424a59", // --text-heading
      secondary: "#5d6d83", // --text-muted
    },
  },
  typography: {
    fontFamily: "Lato, sans-serif", // --font-family-base
  },
  // The kit ui/Dialog overlay sits at --z-dialog (99999), above MUI's stock
  // scale, which tops out at 1500. `modal` is the one key that lifts every
  // portaled surface: Select menus render through Popover -> Modal, and
  // Autocomplete's popper styles itself to zIndex.modal too. The values mirror
  // --z-dialog-popover in src/styles/semantic.css, which a theme cannot read, and
  // keep MUI's modal < snackbar < tooltip ordering.
  zIndex: {
    modal: 100000, // --z-dialog-popover
    snackbar: 100001,
    tooltip: 100002,
  },
  components: {
    // MUI's ButtonBase strips the native focus outline and expects the theme
    // to style keyboard focus — without this, Tabs, IconButtons and Buttons
    // take focus invisibly (WCAG 2.4.7).
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.Mui-focusVisible": {
            outline: "2px solid #01bcd4", // --action-brand
            outlineOffset: "2px",
          },
        },
      },
    },
  },
});
